import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Balanced Lifestyle', path: '/balanced-lifestyle' },
    { name: 'Tips', path: '/tips' },
    { name: 'Standard Drinks Calculator', path: '/standard-drinks', multiline: true },
    { name: 'Parents & Teens', path: '/parents-teens' },
    { name: 'SMASHED', path: '/smashed' },
    { name: 'Pregnancy & Alcohol', path: '/pregnancy' },
    { name: 'Who We Are', path: '/who-we-are' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_new-cheers-nz/artifacts/wnmrmuev_Cheers-Core-logo-positive.png" 
              alt="Cheers!" 
              className="h-14 group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center">
            {navItems.map((item, index) => (
              <React.Fragment key={item.path}>
                <Link
                  to={item.path}
                  className={`px-2 py-2 rounded-md text-sm font-medium transition-all duration-200 hover:bg-white/20 ${
                    isActive(item.path) ? 'bg-white/30' : ''
                  } ${item.multiline ? 'text-center leading-tight' : ''}`}
                  style={item.multiline ? { maxWidth: '80px', lineHeight: '1.2' } : {}}
                >
                  {item.name}
                </Link>
                {index < navItems.length - 1 && (
                  <div className="h-6 w-px bg-white/30 mx-1"></div>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-md hover:bg-white/20 transition-colors"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="lg:hidden bg-teal-700 border-t border-teal-500">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-white/20 transition-colors ${
                  isActive(item.path) ? 'bg-white/30' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;